<template lang="pug">
  .component-driver-controller
    .row
      .columns.small-6
        driver(:type="'driver-card'", :item="item")
      .columns
        .card
          .inner-content
            .field-status
              .label Status
              .field-value {{item.status}}
    .row
      .columns.small-6
        driver(:type="'highlightedNotes'", :item="item")
    .row
      .columns
        router-tab-headers#driver-details(:tabs="tabs")
          router-view


</template>
<script type="text/babel">
import Driver from 'components/backoffice/Driver'
import RouterTabHeaders from "components/structure/foundation/RouterTabHeaders";

export default {
  name: "DriverController",
  components: {
    RouterTabHeaders,
    Driver,
  },
  data() {
    return {
      driverLicense: null,
      tabs: [
        {
          headerName: 'Profile',
          name: 'driver',
          pathName: 'profile'
        }
      ]
    }
  },
  created() {
    const aclMap = new Map([[
      'driver-index-reservations', {
        headerName: 'Reservations',
        name: 'driver-reservations',
        pathName: 'reservations'
      }], [
      'get-driver-subscriptions-subscriptions', {
        headerName: 'Subscriptions',
        name: 'driver-subscriptions',
        pathName: 'subscriptions'
      }], [
      'licenses-drivers', {
        headerName: 'Driver Licenses',
        name: 'driver-licenses',
        pathName: 'driver-licenses'
      }], [
      'coupons-driver', {
        headerName: 'Coupons',
        name: 'driver-coupons',
        pathName: 'driver-coupons'
      }], [
      'cards-drivers', {
        headerName: 'Cards',
        name: 'driver-cards',
        pathName: 'driver-cards'
      }], [
      'tocs-driver', {
        headerName: 'Tocs',
        name: 'driver-tocs',
        pathName: 'driver-tocs'
      }], [
      'index-log', {
        headerName: 'Logs',
        name: 'driver-logs',
        pathName: 'driver-logs'
      }]
    ])
    aclMap.forEach((val, key) => {
      if (this.$acl(key)) {
        this.tabs.push(val)
      }
    })
  },
  methods: {},
  computed: {},
  props: ['item'],

}
</script>
<style lang="sass" rel="stylesheet/sass">
</style>



// WEBPACK FOOTER //
// Driver.vue?9e21d90c